import reviewsData from './inputReviews.json';

export interface InputReview {
  author: string;
  date: string;
  rating: number;
  text: string;
  platform: string;
}

export const inputReviews: InputReview[] = reviewsData;
